module.exports = __webpack_public_path__ + "img/start-dark.66bdb159.png";